import React from 'react';
import withStyles from 'components/common/wrappers/withStyles';

const PauseButton = ({ width, height, color, onClick }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="0000000" width={width} height={height} viewBox="-1.6 -1.6 19.20 19.20" stroke="0000000" onClick={onClick}>

      <g id="SVGRepo_bgCarrier" strokeWidth="0" transform="translate(1.2800000000000002,1.2800000000000002), scale(0.84)">
        <rect x="-1.6" y="-1.6" width="19.20" height="19.20" rx="9.6" fill={color} strokeWidth="0"/>
      </g>
      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round" stroke="#CCCCCC" strokeWidth="0.032"/>
      <g id="SVGRepo_iconCarrier"> <path d="M0 8c0 4.418 3.59 8 8 8 4.418 0 8-3.59 8-8 0-4.418-3.59-8-8-8-4.418 0-8 3.59-8 8zm2 0c0-3.307 2.686-6 6-6 3.307 0 6 2.686 6 6 0 3.307-2.686 6-6 6-3.307 0-6-2.686-6-6zm7 3h2V5H9v6zm-4 0h2V5H5v6z" fillRule="evenodd"/> </g>

    </svg>
  );
};

PauseButton.defaultProps = {
  color: 'white',
};

export default withStyles(PauseButton);